export const componentName = 'ImageInfoViewer';
